import React, { useState, useEffect, useMemo } from "react";
import styles from "../ClientsSay/ClientsSay.module.css";
import TitleBar from "../../TitleBar/TitleBar";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";
import StartNowBtn from "../../StartNowBtn/StartNowBtn";

const ClientsSay = ({ fetchNMTestimonialdata }) => {
  const slides = useMemo(() => {
    const list = fetchNMTestimonialdata?.slides || [];
    return list.map((s, i) => ({
      id: s.id ?? i + 1,
      text: s.text || "",
      author: s.author || "",
      img: s.img?.src || "",
      imgAlt: s.img?.alt || "testimonial",
      bgColor: s.bgColor || "#000000",
      textColor: s.textColor || "#ffffff",
    }));
  }, [fetchNMTestimonialdata]);

  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = () => {
    setPrev(current);
    setCurrent((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setPrev(current);
    setCurrent((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  // Autoplay
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(nextSlide, 3000);
      return () => clearInterval(interval);
    }
  }, [isPaused, current]);

  // Clear previous after fade-out duration
  useEffect(() => {
    if (prev !== null) {
      const timeout = setTimeout(() => setPrev(null), 600);
      return () => clearTimeout(timeout);
    }
  }, [prev]);

  return (
    <div className={styles.containerBox}>
      <div className={styles.TitleBarDiv}>
        <TitleBar blocks={fetchNMTestimonialdata?.subTitle} />
      </div>

      <div className={styles.sliderWrapper}>
        <div
          className={styles.sliderContainer}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {slides.map((slide, index) => {
            let position = styles.hidden;
            if (index === current) position = styles.active;
            else if (index === prev) position = styles.fadeOut;
            else if (index === (current + 1) % slides.length)
              position = styles.next;
            else if (index === (current + 2) % slides.length)
              position = styles.next2;

            return (
              <div
                key={slide.id}
                className={`${styles.slide} ${position}`}
                style={{
                  backgroundColor: slide.bgColor,
                  color: slide.textColor,
                }}
              >
                <div className={styles.textSection}>
                  <p>{slide.text}</p>
                  <span>{slide.author}</span>
                </div>
                <div className={styles.imageSection}>
                  <img src={slide.img} alt={slide.author} />
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.controls}>
          <div
            className={styles.btn}
            onClick={() =>
              window.open(
                "https://app.rxpt.ai/",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            {/* <AnimatedBtn text2="Join" logo="/Svg/rexpt-logo2.svg" shapeType="alt"/> */}
            {/* <img src="/Svg/join-btn2.svg" alt="join-btn2" /> */}
            <StartNowBtn
                            mainText="FREE SIGNUP"
                            subText="No Credit Card needed"
                            underline=""
                            bold=""
                          />
          </div>
          <div className={styles.BothBtn}>
            {/* <button onClick={prevSlide}>
                            <FaArrowLeft />
                        </button> */}
            <button onClick={nextSlide}>
              <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsSay;
